"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var utilities_1 = require("../../utilities");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
require("./sis-tooltip-settings.component.scss");
var TooltipSettingsComponent = /** @class */ (function (_super) {
    __extends(TooltipSettingsComponent, _super);
    function TooltipSettingsComponent(communicationService) {
        return _super.call(this, communicationService) || this;
    }
    TooltipSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-tooltip-settings',
            template: require('./sis-tooltip-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-tooltip-settings\n                    [languages]=\"%{languages}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\"\n                    [state]=\"%{state}\">\n               </sis-tooltip-settings>",
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService])
    ], TooltipSettingsComponent);
    return TooltipSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.TooltipSettingsComponent = TooltipSettingsComponent;
/*tslint:disable:max-classes-per-file*/
/**
 * @deprecated use TooltipSettings from ng-controls
 */
var TooltipSettings = /** @class */ (function () {
    function TooltipSettings(isWithTooltip, caption, content) {
        this.isWithTooltip = isWithTooltip;
        this.caption = caption;
        this.content = content;
    }
    TooltipSettings.createEmptyFrom = function (languages) {
        var languageIds = languages.map(function (language) { return language.getId(); });
        var caption = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().withValueForLanguages(languageIds, '').build();
        var content = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().withValueForLanguages(languageIds, '').build();
        return new TooltipSettings(false, caption, content);
    };
    TooltipSettings.fromJsonString = function (json) {
        var obj = JSON.parse(json);
        return new TooltipSettings(obj['isWithTooltip'], utilities_1.stringToMultilingual(obj['caption']), utilities_1.stringToMultilingual(obj['content']));
    };
    TooltipSettings.prototype.toJsonString = function () {
        return JSON.stringify({
            isWithTooltip: this.isWithTooltip,
            caption: utilities_1.multilingualToString(this.caption),
            content: utilities_1.multilingualToString(this.content)
        });
    };
    return TooltipSettings;
}());
exports.TooltipSettings = TooltipSettings;
//# sourceMappingURL=sis-tooltip-settings.component.js.map